import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmApiTaskCommentNotFoundError } from '@/core/error/transport/tmApiTaskCommentNotFoundError'

export const tasksCommentNotFoundErrorRule: CustomErrorRule = {
  klass: TmApiTaskCommentNotFoundError,
  predicateFn: (error) => {
    return error.response.data.message.includes('TaskComment object not found')
  },
}
